import type { SelectProps } from 'antd';
import type { ChartMultiTagOpts } from './chartFilterMultiTagRender';
import { chartMultiSelectTagRender } from './chartFilterMultiTagRender';

/** True when every enabled Z option at this level is selected and there are no extra values. */
export function isZLevelAllSelected(
    levelOptions: Array<{ value: string; disabled: boolean }> | undefined,
    selected: string[] | undefined,
): boolean {
    const enabled = (levelOptions ?? []).filter((o) => !o.disabled).map((o) => o.value);
    if (enabled.length === 0) return false;
    const sel = selected ?? [];
    if (sel.length !== enabled.length) return false;
    const selSet = new Set(sel);
    return enabled.every((v) => selSet.has(v));
}

export function getFirstEnabledZOptionValue(
    levelOptions: Array<{ value: string; disabled: boolean }> | undefined,
): string | undefined {
    return (levelOptions ?? []).find((o) => !o.disabled)?.value;
}

export function zAxisSelectTagRender(
    zSelected: string[],
    allSelected: boolean,
    firstEnabledValue: string | undefined,
    getLabelForValue: (v: string) => string,
): SelectProps['tagRender'] {
    let opts: ChartMultiTagOpts;
    if (allSelected && firstEnabledValue !== undefined) {
        opts = { kind: 'zAll', firstTagValue: firstEnabledValue };
    } else {
        opts = undefined;
    }
    return chartMultiSelectTagRender(zSelected, getLabelForValue, opts);
}
